import React,{ useContext} from "react";

import { AppContext } from "../../../AppContext";
import DateUtil from "../../../common/dateUtil";
import CommentComp from "../../common/CommentComp";


const ObaDetail = (props)=>{
  const [appContext, setAppContext] = useContext(AppContext);
  const isJwCole = appContext.clientId === "jwcole"?true:false;
    const DefaultDetail = ()=>{
        
            return(
                <div className="panel-body">
                <div className="panel-columns">
        
                    <div className="panel-column">
                    
                        <div className="panel-item">
                            <div className="panel-item-label">Name of Business :</div>
                            <div className="panel-item-value">{props.data.businessName}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Business Type :</div>
                            <div className="panel-item-value">{props.data.businessType}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Business Description :</div>
                            <div className="panel-item-value">{props.data.businessDesc}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Business Address :</div>
                            <div className="panel-item-value">{props.data.businessAddress}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Yearly Income from OBA :</div>
                            <div className="panel-item-value">{props.data.yearlyIncome}</div>
                        </div>
        
                    </div>
                    
                    <div className="panel-column">
        
                        <div className="panel-item">
                            <div className="panel-item-label">Compensation Method :</div>
                            <div className="panel-item-value">{props.data.compensationMethod}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Engagement % of Time :</div>
                            <div className="panel-item-value">{props.data.engagementTime}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Business Structure :</div>
                            <div className="panel-item-value">{props.data.businessStructure}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Activity Start Date :</div>
                            <div className="panel-item-value">{props.mode==="DETAIL"?props.data.activityStartDate:DateUtil.toStrDate(props.data.activityStartDate)}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Business Custody :</div>
                            <div className="panel-item-value">{props.data.businessCustody}</div>
                        </div>
                    {props.data.attachment && 
                        <div className="panel-item">
                            <div className="panel-item-label">Attachment Document :</div>
                            <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                        </div>
                    }
                    {props.data.employeeName &&
                        <div className="panel-item">
                            <div className="panel-item-label">Employee :</div>
                            <div className="panel-item-value">{props.data.employeeName}</div>
                        </div>
                    }
                    {props.data.submittedForLabel &&
                        <div className="panel-item">
                            <div className="panel-item-label">Submit On Behalf of :</div>
                            <div className="panel-item-value">{props.data.submittedForLabel}</div>
                        </div>
                    }
                    {props.data.submittedBy &&
                        <div className="panel-item">
                            <div className="panel-item-label">Submitted By :</div>
                            <div className="panel-item-value">{props.data.submittedBy}</div>
                        </div>
                    }
            
        
                    </div>
        
                </div>
        
                <CommentComp data = {props.data.comments}/>
        
            </div>
            );

    }
    
    const JwColeDetail = ()=>{
      

        const BusinessRelations = (props)=>{
            return(
                <ul className="bullete-list">
                    {props.businessRelations.map((item,idx)=>
                        <li key = {item.key}>{item.value}</li>
                    )}
                </ul>
            );
        }


        return(
            <div className="panel-body">
                <div className="panel-columns">
        
                    <div className="panel-column">
                    
                        <div className="panel-item">
                            <div className="panel-item-label">Name of OBA :</div>
                            <div className="panel-item-value">{props.data.businessName}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Is this a DBA :</div>
                            <div className="panel-item-value">{props.data.isDba}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Is your DBA registered in your home state? :</div>
                            <div className="panel-item-value">{props.data.isDbaHomeState}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Address of OBA :</div>
                            <div className="panel-item-value">{props.data.businessAddress}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Nature of OBA :</div>
                            <div className="panel-item-value">{props.data.businessDesc}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Anticipated Start Date :</div>
                            <div className="panel-item-value">{props.mode==="DETAIL"?props.data.activityStartDate:DateUtil.toStrDate(props.data.activityStartDate)}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Title/Position :</div>
                            <div className="panel-item-value">{props.data.titlePosition}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Type of Business Organization: </div>
                            <div className="panel-item-value">{props.data.businessType}</div>
                        </div>
        
                     
                        <div className="panel-item">
                            <div className="panel-item-label">Name of Organization: </div>
                            <div className="panel-item-value">{props.data.businessOrganizationName}</div>
                        </div>
        
                       
        
                        <div className="panel-item">
                            <div className="panel-item-label">Clients own securities issued by the corporation in their J.W. Cole account(s): </div>
                            <div className="panel-item-value">{props.data.clientAccount}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Partner Type: </div>
                            <div className="panel-item-value">{ props.data.rdoPartnerType ==="Other"? (props.data.partnerType ||props.data.rdoPartnerType):props.data.rdoPartnerType  }</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Relationship to the OBA: </div>
                            <div className="panel-item-value">{props.data.businessRelations && <BusinessRelations businessRelations={props.data.businessRelations}/>} </div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Anticipated Annual Compensation: </div>
                            <div className="panel-item-value">{props.data.yearlyIncome}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Nature of the compensation (e.g., salary, commissions, hourly wage, equity, etc.): </div>
                            <div className="panel-item-value">{props.data.compensationMethod}</div>
                        </div>
        
                    </div>
                    
                    <div className="panel-column">
        
        
                        <div className="panel-item">
                            <div className="panel-item-label">Duties and obligations in connection with this OBA: </div>
                            <div className="panel-item-value">{props.data.businessDuty}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Number of hours per month spent during trading hours: </div>
                            <div className="panel-item-value">{props.data.engagementTime}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Please provide any website URLs relating to this activity: </div>
                            <div className="panel-item-value">{props.data.businessUrl}</div>
                        </div>
        
        
                        <div className="panel-item">
                            <div className="panel-item-label">Does the activity involve investments or securities business?: </div>
                            <div className="panel-item-value">{props.data.isInvestSecurity}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Does the activity involve fundraising, soliciting ownership or other methods of raising capital?: </div>
                            <div className="panel-item-value">{props.data.isFundraising}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Fundraising, soliciting ownership or other methods of raising capital: </div>
                            <div className="panel-item-value">{props.data.fundraisingDesc}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Are you an Investment Advisory Representative?: </div>
                            <div className="panel-item-value">{props.data.isInvestmentRep}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Does this business activity account for 10% or more of your time?: </div>
                            <div className="panel-item-value">{props.data.isEngageMoreThan10Percent}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Does this business activity account for 10% or more if your income?: </div>
                            <div className="panel-item-value">{props.data.isIncomeMoreThan10Percent}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Does this business activity account for 10% or more if your income?: </div>
                            <div className="panel-item-value">{props.data.isIncomeMoreThan10Percent}</div>
                        </div>
        
                        <div className="panel-item">
                            <div className="panel-item-label">Do you plan to or have you solicited any individual(s) to invest in this activity?: </div>
                            <div className="panel-item-value">{props.data.isSolicitedInvest}</div>
                        </div>

                        {props.data.isSolicitedInvest==="Yes" && props.data.solicitedInvestors && props.data.solicitedInvestors.length>0 &&
                        <>
                            <div className="panel-item mt-2rem">
                                <div className="panel-item-label">Solicited any individual(s): </div>
                                <div></div>
                            </div>
        
                            <ul>
                                {props.data.solicitedInvestors.map((item,idx)=>{
                                    return (
                                        <li key={idx}>
                                            <div className="panel-item">
                                                <div className="panel-item-label">Individual's Name :</div>
                                                <div className="panel-item-value">{item.investorName}</div>
                                            </div>
                                            <div className="panel-item">
                                                <div className="panel-item-label">Your relationship to the individual :</div>
                                                <div className="panel-item-value">{item.investorRelation}</div>
                                            </div>
                                            <div className="panel-item">
                                                <div className="panel-item-label">Investment amount :</div>
                                                <div className="panel-item-value">{item.investmentAmount}</div>
                                            </div>
                                            <div className="panel-item">
                                                <div className="panel-item-label">Date of investment :</div>
                                                <div className="panel-item-value">{DateUtil.toStrDate(item.investmentDate)}</div>
                                            </div>
                                            <div className="panel-item">
                                                <div className="panel-item-label">Nature of the individual's involvement with the activity :</div>
                                                <div className="panel-item-value">{item.involvementType}</div>
                                            </div>                                                
                                        </li>
                                    );
                                })
                                }
                            </ul>
                        </>
                        }


        
        
                        <div className="panel-item mt-2rem">
                            <div className="panel-item-label">Outside of investments, are any clients or J.W. Cole associated persons involved in this activity?: </div>
                            <div className="panel-item-value">{props.data.isActivityInvolve}</div>
                        </div>

                        {props.data.isActivityInvolve==="Yes" && props.data.activityInvolvedPeople && props.data.activityInvolvedPeople.length>0 &&
                        <>
                            <div className="panel-item mt-2rem">
                                <div className="panel-item-label">Solicited any individual(s): </div>
                                <div></div>
                            </div>
        
                            <ul>
                                {props.data.activityInvolvedPeople.map((item,idx)=>{
                                    return (
                                        <li key={idx}>
                                            <div className="panel-item">
                                                <div className="panel-item-label">Client or Associated Person Name :</div>
                                                <div className="panel-item-value">{item.name}</div>
                                            </div>
                                            <div className="panel-item">
                                                <div className="panel-item-label">Account number(s) :</div>
                                                <div className="panel-item-value">{item.accountNumbers}</div>
                                            </div>
                                            <div className="panel-item">
                                                <div className="panel-item-label">Nature of the individual's involvement with the activity :</div>
                                                <div className="panel-item-value">{item.involvementType}</div>
                                            </div>                                                
                                        </li>
                                    );
                                })
                                }
                            </ul>
                        </>
                        }

        
        
                        <div className="panel-item mt-2rem">
                            <div className="panel-item-label">Will you have check-writing, trading authority, custody or control relating to this activity?: </div>
                            <div className="panel-item-value">{props.data.isBusinessCustody}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Description of Custody: </div>
                            <div className="panel-item-value">{props.data.businessCustody}</div>
                        </div> 
        
                        <div className="panel-item">
                            <div className="panel-item-label">Check-writing, required two signatures : </div>
                            <div className="panel-item-value">{props.data.requiresTwoSignCheck}</div>
                        </div> 
        
                        <div className="panel-item">
                            <div className="panel-item-label">Will you be covered under separate E & O or D & O (directors and officers) insurance or fidelity bond for this activity? : </div>
                            <div className="panel-item-value">{props.data.insuranceCovered}</div>
                        </div> 
        
                        <div className="panel-item">
                            <div className="panel-item-label">Please include any other information you wish J.W. Cole to consider during our review of this activity : </div>
                            <div className="panel-item-value">{props.data.otherInfo}</div>
                        </div> 
        
                        
                        {props.data.attachment && 
                        <div className="panel-item">
                            <div className="panel-item-label">Attachment Document :</div>
                            <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                        </div>
                        }
                        {props.data.employeeName &&
                        <div className="panel-item">
                            <div className="panel-item-label">Employee :</div>
                            <div className="panel-item-value">{props.data.employeeName}</div>
                        </div>
                        }
                        {props.data.submittedForLabel &&
                            <div className="panel-item">
                                <div className="panel-item-label">Submit On Behalf of :</div>
                                <div className="panel-item-value">{props.data.submittedForLabel}</div>
                            </div>
                        }
                        {props.data.submittedBy &&
                            <div className="panel-item">
                                <div className="panel-item-label">Submitted By :</div>
                                <div className="panel-item-value">{props.data.submittedBy}</div>
                            </div>
                        }

                    </div>
        
                </div>
      
                <CommentComp data = {props.data.comments}/>

    
        </div>
        );        
    }

    return (
        <>
            {!isJwCole && <DefaultDetail mode="DETAIL"/>}
            {isJwCole && <JwColeDetail mode="DETAIL"/>}
        </>
    );

}

export default ObaDetail;
